export default "__VITE_ASSET__DBL1kM3x__"